import { AbstractControl, ValidationErrors } from '@angular/forms';

export function AlphaNumeric(control: AbstractControl): ValidationErrors | null {
    const regex = new RegExp(/^[a-z\d\-_\s]+$/i);
    if (!regex.test(control.value)) {
        return { onlyAlphanumeric: true };
    }
    return null;
}
